// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';

// Components
import Checkbox from '../core/checkbox';
import FormButtons from '../core/form-buttons';
import Input from '../core/input';
import Permissions from '../core/permissions';
import SearchPagination from '../app/search-pagination';
import SearchTableWithSort from '../app/search-tablewithsort';
import ServicesExportPanelAction from '../app/services-export-panel-action';
import ServicesSearchForm from '../app/services-search-form';
import ServicesSearchPanelAction from '../app/services-search-panel-action';

// Containers
import withSearch from '../../containers/with-search';

const servicesDataKey = 'users';

class Users extends Component {
    getColumnConfig() {
        return [
            {
                dataKey: 'clientId',
                link: '/admin/users',
                linkKey: 'clientId',
                title: 'User',
                type: 'link',
                width: '20%',
            },
            {
                dataKey: 'active',
                title: 'Active',
                width: '10%',
            },
            {
                dataKey: 'name',
                title: 'Full Name',
                width: '15%',
            },
            {
                dataKey: 'email',
                title: 'Email',
                width: '15%',
            },
            {
                dataKey: 'scope',
                formatter: 'roles',
                title: 'Groups',
                width: '40%',
            },
        ];
    }

    getPaginationProps() {
        const {query, totalPages} = this.props;

        return {
            maxPages: 9,
            query,
            totalPages,
        };
    }

    getTablewithsortProps() {
        return {
            ...this.props,
            ...{
                activeRowKey: 'clientId',
                activeRowValueKey: 'routerParams.clientId',
                columnConfig: this.getColumnConfig(),
                notSortable: ['scope'],
                rowDetails: {
                    whitelistKeys: ['accessTokenValiditySeconds', 'refreshTokenValiditySeconds'],
                    blacklistKeys: ['preferences'],
                },
                servicesDataKey,
                updateOnUrlChange: false,
            },
        };
    }

    renderForm = () => (
        <ServicesSearchForm formName={servicesDataKey} servicesDataKey={servicesDataKey}>
            <Input label="Username" name="clientId" title="Use wildcard (*) for partial username match" />
            <Checkbox label="Active Only" name="active" value="true" />
            <FormButtons />
        </ServicesSearchForm>
    );

    render() {
        const {searchData} = this.props;

        return (
            <Permissions adminOnly={true} notAuthorizedMessage={true}>
                <div className="users">
                    <ServicesExportPanelAction searchData={searchData} />
                    <ServicesSearchPanelAction contentRenderer={this.renderForm} />
                    <SearchPagination {...this.getPaginationProps()} />
                    <SearchTableWithSort {...this.getTablewithsortProps()} />
                </div>
            </Permissions>
        );
    }
}

Users.propTypes = {
    query: PropTypes.object,
    searchData: PropTypes.array,
    totalPages: PropTypes.number,
};

export default withSearch(Users, servicesDataKey);
